import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes/theme";

type ProposalViewIconProps = IconT & {
  circleFill?: string;
};

export default function ProposalViewIcon({
  height = "24",
  width = "24",
  fill = theme.colors["darkest-blue"],
  circleFill = theme.colors["athens-gray"],
}: ProposalViewIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={circleFill} />
      <path
        d="M3.21845 12.6534C3.09361 12.4558 3.03119 12.3569 2.99625 12.2045C2.97 12.09 2.97 11.9094 2.99625 11.7949C3.03119 11.6424 3.09361 11.5436 3.21845 11.3459C4.25007 9.71244 7.32078 5.58301 12.0004 5.58301C16.68 5.58301 19.7507 9.71244 20.7823 11.3459C20.9071 11.5436 20.9696 11.6424 21.0045 11.7949C21.0307 11.9094 21.0307 12.09 21.0045 12.2045C20.9696 12.3569 20.9071 12.4558 20.7823 12.6534C19.7507 14.2869 16.68 18.4163 12.0004 18.4163C7.32078 18.4163 4.25007 14.2869 3.21845 12.6534Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0004 14.7497C13.5192 14.7497 14.7504 13.5185 14.7504 11.9997C14.7504 10.4809 13.5192 9.24967 12.0004 9.24967C10.4816 9.24967 9.25037 10.4809 9.25037 11.9997C9.25037 13.5185 10.4816 14.7497 12.0004 14.7497Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
